import Places from 'constants/places'
import type { ExperienceSearchFallbackPlace } from 'tripPlanner/api/types'

export function getConcreteExperienceSearchPlace(searchUrl: string): ExperienceSearchFallbackPlace | undefined {
  const searchParams = new URLSearchParams(searchUrl.split('?')[1] ?? '')
  const destinationId = searchParams.get('destinationId')
  const destinationName = searchParams.get('destinationName')

  if (!destinationId || !destinationName || destinationId === Places.Anywhere.id) {
    return undefined
  }

  return {
    placeId: destinationId,
    name: destinationName,
  }
}
